import React, { memo } from 'react'
import { GiCheckMark } from "react-icons/gi";
import { FaCheck } from "react-icons/fa";
import { ImCross } from "react-icons/im";

function CheckAndCrossMarksForCenterCards({ seats = [], getCenterCardPos = () => { } }) {
    const ordered = [...seats].sort((a, b) => {
        if (a.isMe && !b.isMe) return 1
        if (!a.isMe && b.isMe) return -1
        return 0
    })
    return (
        <div className='checkAndCrossDiv'>
            {
                ordered.map((seat, index) => {
                    const trickWins = seat.trickWins.filter(ele => ele) ?? []
                    // const trickWins = ["win", "win", "win"]
                    return (<div className='checkAndCrossBox'>
                        {trickWins.map((outcome, i) => {
                            const { x, y, width, height } = getCenterCardPos(index, "", i + 1)
                            return (
                                <span className='trucoCardCheckCross' style={{ width, display: 'flex', justifyContent: "center", position: "fixed", left: 0, top: 0, transform: `translate(${x}px, ${y - (((1 - index) * (height + 50)))}px)` }}>
                                    {outcome === "win" ? <FaCheck fill='#00ff00' /> :
                                        <ImCross fill='red' />}
                                </span>
                            )
                        })}
                    </div>)
                })
            }
        </div >
    )
}

export default memo(CheckAndCrossMarksForCenterCards)